module.exports = __webpack_public_path__ + "img/icons-fill-integrations.73fb26ce.svg";